import React, {useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import FilterRow from "../components/FilterRow";
import {colorFunctions} from "../constants/colors";

export default function FilterTypeRow({label, filters}){
	
	const [displayFilters, setDisplayFilters] = useState("none");
	const [icon, setIcon] = useState("angle-right");
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		flexDirection:"column"
	};
	
	const titleRow = {
		display:"flex",
		height:"30px",
		width:'100%',
		alignItems:"center"
	}
	
	const iconStyle = {
		display:"flex",
		color:colorFunctions.getSecondaryColor(),
		width:"20px",
		height:"20px",
		margin:"10px",
		cursor:"pointer"
	};
	
	const labelStyle ={
		display:"flex",
		color:"black",
		fontSize:"14px"
	};
	
	
	const handleClick = () => {
		if(displayFilters === "none"){
			setDisplayFilters("flex");
			setIcon("angle-down");
		}
		else{
			setDisplayFilters("none");
			setIcon("angle-right");
		}
	};
	
	const filterContainer = {
		display:displayFilters,
		marginLeft:"10px",
		width:"calc(100% - 10px)",
		flexDirection:'column',
		paddingBottom:"10px"
	};
	
	const filterDisplay = filters.map((item, index) => 
		<FilterRow
			label={item.label}
			filters={item.filters}
		/>
	);
	
	return (
		<div style={thisContainer}>
			<div style={titleRow}>
				<FontAwesomeIcon icon={icon} style={iconStyle} onClick={handleClick}/>
				<div style={labelStyle}>
					{label}
				</div>
			</div>
			<div style={filterContainer}>
				{filterDisplay}
			</div>
		</div>
	);
}